.collapseMenu {
  right: -5px;
  max-height: 370px;
}

.headerButton {
  @include themify($themes) {
    border: 1px solid themed("neutral-secondary");
    background-color: themed("main-secondary");
    color: themed("neutral-to-primary");
  }
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.25s ease-out;

  svg {
    width: 14px;
    height: 14px;
    opacity: 0.9;
    @include themify($themes) {
      @if $theme == "dark" {
        color: themed("color_active_tab-secondary");
      } @else {
        color: themed("neutral-primary");
      }
    }
  }

  &:not(.disabled):hover,
  &:not(.disabled).selected {
    svg {
      opacity: 1;
    }
    @include themify($themes) {
      background-color: themed("brand-secondary");
    }
  }

  &.disabled {
    cursor: default;
    opacity: 0.3;
    pointer-events: none;
  }
}

.optionWrapper {
  padding: 0 12px;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 8px;
  }
}

.optionContainer {
  padding: 4px 8px;

  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.25s ease-out;
}

.option {
  pointer-events: none;
  background-color: unset;
}

.dateRangeContainer {
  .optionWrapper:first-child {
    margin-bottom: unset;
  }
}

.byLastMonthsContainer,
.dateRangeContainer {
  display: flex;
  flex-direction: column;

  height: fit-content;
  transition:
    max-height 0.25s ease-out,
    margin-bottom 0.25s ease-out;
  max-height: 30px;
  overflow: hidden;

  .optionContainer {
    &:hover {
      transition: background-color 0.25s ease-in;
      @include themify($themes) {
        background-color: themed("neutral-tertiary");
      }
    }
  }

  &.active {
    transition:
      max-height 0.25s ease-in,
      margin-bottom 0.25s ease-in;
    max-height: 300px;

    .fromToDateWrapper,
    .byLastMonthsValuesContainer {
      transition:
        max-height 0.25s ease-in,
        margin-bottom 0.25s ease-in;
    }

    .optionContainer.option {
      background-color: none;
    }

    .optionContainer {
      font-size: 13px;
      font-weight: 500;
    }
  }

  .optionContainer {
    pointer-events: all;
    min-height: 30px;
    &:hover {
      transition: background-color 0.25s ease-in;
      @include themify($themes) {
        background-color: themed("neutral-tertiary");
      }
    }

    &.option {
      font-size: 16px;
      font-weight: 400;
      &.selected {
        @include themify($themes) {
          background-color: themed("neutral-tertiary");
        }
      }
    }

    &.selected {
      &:hover {
        cursor: default;
        background-color: transparent;
      }
    }
  }

  .fromToDateWrapper {
    transition:
      max-height 0.25s ease-out,
      margin-bottom 0.25s ease-out;
  }
}

.byLastMonthsContainer {
  &:not(.selected) {
    margin-bottom: 12px;
  }
}

.applyDateRangeButtonContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;

  > button {
    width: 100%;
    margin: 0 20px;
  }
}

.byLastMonthsContainer {
  margin-bottom: 4px;
}

.fromDateContainer,
.toDateContainer {
  padding: 0 20px;

  label {
    font-size: 13px;
    font-weight: 500;
  }
}

.toDateContainer {
  padding-top: 12px;
}

.fromDateContainer {
  padding-top: 4px;
}

.dateRangeAndByMonthSeparator {
  margin: 12px 0px;
  @include themify($themes) {
    border-top: solid 1px themed("neutral-tertiary");
  }
}

.byMonthIsHidden {
  padding-bottom: 12px;
}
